<template>
	<div class="index" id="main">
		<div class="box box1" :class="init?'init':''"  ref="box1">
			<div class="" :class="swiperIdx==0?'tow':'one'">
				<swiper :list="windowWidth > 820?banner:mBanner" ref="student"/>
				<div class="text" v-if="swiperIdx==0">
					<div class="fs45 fw mt30 cor-27">五润<span>.</span>只为更好生活</div>
					<div class="fs22 let-spc6 cor-27">构建一个美好、和谐的社区生活平台</div>
					<div class="cor-8f fs10 let-spc6">Where there is a community there is weroom</div>
				</div>
				<div class="text" v-if="swiperIdx==1">
					<div class="fs45 fw mt30 cor-27">有社区，就有五润</div>
					<div class="fs22 let-spc6 cor-27">构建一个美好、和谐的社区生活平台</div>
					<div class="cor-8f fs10 let-spc6">Where there is a community there is weroom</div>
				</div>
			</div>
		</div>
		<div class="box box2" ref="box2">
			<div class="text">
				<div class="wurunBg">
					<img src="https://qiniuimg.wurun.net/%E6%96%B0%E7%89%88/w.png" mode="widthFix" alt="" class="img">
					<div class="flex">
						<img src="https://qiniuimg.wurun.net/%E6%96%B0%E7%89%88/index_bg1.png" mode="widthFix">
						<div class="flex">
							<div>
								<p class="tit" v-if="windowWidth > 820">
									<svgIcon iconClass="logo" class="logo" style="color:#fff;width:167px;height:50px;"/>
								</p>
								<div>
									<p>五润集团致力于创建社区发展平台、以完善的生态链服务于社区；同时旗下设有独立的中央厨房、仓储配送分公司及品牌运营中心等核心组织，是一家集产品研发生产、集采贸易、运营管理、信息开发、品牌策划及物流配送为—体的综合性餐饮连锁企业。</p>
									<p>为了能更好的支撑品牌的快速发展及五润集团生态链板块的完整，分别成立了“五润品牌管理有限公司”“五润科技信息有限公司”“厦门九香堂贸易有限公司”与 “佐籽（厦门）食品有限公司”等十余家旗下品牌，来为五润集团旗下品牌进行品牌赋能。</p>
									<p>五润集团采用“一个生态平台服务一家店”生态化运作模式，为中国社区门店品牌做赋能。</p>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="box2Ye flex align-items just-center">
					<div v-for="(d,i) in boxy" :key="i" class="boxy">
						<span class="flex cor-27">
							<countTo :startVal='d.sValue' :endVal='d.value' :duration='4000' :separator="''"/>
							<p class="fs39">+</p>
						</span>
						<p>{{d.name}}</p>
					</div>
				</div>
			</div>
		</div>
		<div class="box box3" ref="box3">
			<div class="tit">
				<span class="cor-27">六大服务体系</span>
				<div class="center fs18">历经17年的沉淀，在各产业链上的高速发展及不断完善后，<br/>
五润将多元化的商业运作方式形成六大服务体系，以一条龙的方式全面赋能于旗下各个门店。</div>
			</div>
			<div class="list">
				<div v-for="(d,i) in box3" :key="i">
					<img :src="d.url" alt="" mode="widthFix">
					<div>
						<div class="fs24 fw name">{{d.name}}</div>
						<div class="text">{{d.text}}</div>
					</div>
				</div>
			</div>
		</div>
		<div class="box box4" ref="box4">
			<img src="https://qiniuimg.wurun.net/%E6%96%B0%E7%89%88/index_bg.png" alt="" class="bgc">
			<div class="">
				<div class="tit">
					<span class="cor-f">品牌优势</span>
				</div>
				<div class="list flex" :class="scrollTop>=1000?'active':''">
					<div v-for="(d,i) in box4" :key="i">
						<div class="box">
							<div class="fs18 title">{{d.tit}}</div>
							<div class="text cor-f">{{d.text}}<br/>{{d.text2}}</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="box box5" ref="box5">
			<div class="tit">
				<span class="cor-27">集团业务</span>
				<div class="center fs18">一日之计在于晨，五润为迎接美好一天的人们提供精致早餐体验；<br/>
					从社区门店精致早餐体验延伸到餐车形式，<br v-if="windowWidth < 820"/>将这份美味传递到城市的各个角落；<br/>
					为讲究精致生活的人，提供精美茶歇；<br v-if="windowWidth < 820"/>为探访亲友的爱心人士，提供轻奢伴手礼；<br/>
					佐籽西点烘焙品牌的精确定位，为人们雅致生活提供美好服务。
				</div>
			</div>
			<div class="list flex">
				<div v-for="(d,i) in box5" :key="i">
					<img :src="d.url" alt="">
					<div class="item">
						<div class="title fs24">{{d.tit}}<br/>{{d.text}}<br/>{{d.text2}} </div>
					</div>
				</div>
			</div>
		</div>
		<div class="box box6" ref="box6">
			<div class="tit cor-27">
				<span>新闻动态</span>
			</div>
			<!-- <img src="https://qiniuimg.wurun.net/%E6%96%B0%E7%89%88/ico_w.png" class="bg" alt=""> -->
			<svgIcon iconClass="w" class="bg"/>
			<div class="btn" v-if="windowWidth > 820">
				<span v-for="(d,i) in newBtn" @click="subNewBtn(i)" :key="i" :class="newBtnActive == i?'cur':''">{{d.name}}</span>
			</div>
			<div class="cont">
				<div class="list flex" :class="newBtnActive==0?'cur':''">
				<div v-for="(d,i) in box6" :key="i" @click="goToNewDetail(d)">
					<img :src="d.url" alt="">
					<div>
						<div class="title fs22 fw">{{d.tit}}</div>
						<div class="time fw fs20">{{d.time}}</div>
						<div class="text fs16 cor-59">{{d.text}}</div>
					</div>
				</div>
			</div>
			<div class="list flex" :class="newBtnActive==1?'cur':''">
				<div v-for="(d,i) in box7" :key="i" @click="goToNewDetail(d)">
					<img :src="d.url" alt="">
					<div>
						<div class="title fs22 fw">{{d.tit}}</div>
						<div class="time fw fs20">{{d.time}}</div>
						<div class="text fs16 cor-59">{{d.text}}</div>
					</div>
				</div>
			</div>
			</div>
			<div class="more" @click="goToNewsList">更多</div>
		</div>
		<rightTab v-if="windowWidth > 820" />
	</div>
</template>

<script>
	import rightTab from "@/components/rightTab.vue"
	import '../../style/css_w/index.css'
	import swiper from "@/components/swiper.vue"
	import Swiper, {Navigation, Pagination}  from 'swiper';
	import countTo from 'vue-count-to';
	Swiper.use([Navigation, Pagination]);
	export default {
		name: 'Home',
		props:['tabIdx'],
		components: {
			rightTab,
			swiper,
			countTo
		},
		data() {
			return {
				swiperIdx:0,
				currentId:0,
				arr:[0,1200,2400,3600,4850,5800,6800],
				listName: [], //滚动的列表
				init: false,
				windowWidth: '',
				banner:['https://qiniuimg.wurun.net/%E6%96%B0%E7%89%88/bg1-pc.jpg','https://qiniuimg.wurun.net/pc/banner.jpg'],
				mBanner:['https://qiniuimg.wurun.net/m_bg1-1.jpg','https://qiniuimg.wurun.net/news/sybanner.jpg'],
				boxy: [{
						sValue:1,
						value: 17,
						name: '年历史'
					},
					{
						sValue:10,
						value: 50,
						name: '荣获奖项'
					},
					{
						sValue:200,
						value: 300,
						name: '五润门店'
					},
					{
						sValue:1200,
						value: 1300,
						name: '五润餐车'
					}
				],
				box3: [ {
					url: 'https://qiniuimg.wurun.net/%E6%96%B0%E7%89%88/tx1.png',
					name: '科技服务',
					text: '一站式信息化建设解决方案'
				},{
					url: 'https://qiniuimg.wurun.net/%E6%96%B0%E7%89%88/tx2.png',
					name: '品牌策划',
					text: '建设集团旗下子公司及业务板块等品牌体系标准化'
				},{
					url: 'https://qiniuimg.wurun.net/%E6%96%B0%E7%89%88/tx3.png',
					name: '运营管理',
					text: '建立并践行五润经营理念标准化营运体系'
				},{
					url: 'https://qiniuimg.wurun.net/%E6%96%B0%E7%89%88/tx4.png',
					name: '中央厨房',
					text: '企业的QS标准无尘车间'
				}, {
					url: 'https://qiniuimg.wurun.net/%E6%96%B0%E7%89%88/tx5.png',
					name: '集采贸易',
					text: '集采、贸易、仓储一条龙'
				},{
					url: 'https://qiniuimg.wurun.net/pc/st10.jpg',
					name: '物流配送',
					text: '独家物流配送整合平台'
				}],
				box4: [{
					svg: 'ys1',
					tit: '强大的信息技术团队',
					text: '提供一站式平台客户服务',
					text2: '以满足五润及其生态产业经营所属的系统平台运营支持'
				},{
					svg: 'ys2',
					tit: '良好的品牌知名度',
					text: '多年品质与服务的沉淀，造就五润社区知名度',
					text2: ''
				}, {
					svg: 'ys4',
					tit: '完善的运营管理',
					text: '标准化的运营流程操作，提供专业的技术指导',
					text2: '及运营管理办法'
				}, {
					svg: 'ys3',
					tit: '丰富的产品体系',
					text: '为了更好的服务于社区',
					text2: '不断的扩展品牌多元化产品体系'
				}, {
					svg: 'ys5',
					tit: '稳定的生态供应链',
					text: '设有独立的中央厨房及仓储运输团队',
					text2: '成熟供应链运作体系'
				}, {
					svg: 'ys6',
					tit: '专业的品牌营销',
					text: '独立的品牌营销团队，专业的品牌推广与线上运营',
					text2: '服务公司，为品牌的宣传建立渠道与窗口'
				}],
				box5: [ {
					logo: 'https://qiniuimg.wurun.net/logo1.png',
					url: 'https://qiniuimg.wurun.net/wr.png',
					tit: '中式餐点',
					text: '面点冻品',
					text2: '节令伴手礼'
				},{
					logo: 'https://qiniuimg.wurun.net/logo3.png',
					url: 'https://qiniuimg.wurun.net/%E6%96%B0%E7%89%88/brand2.png',
					tit: '伴手礼',
					text: '茶歇',
					text2: '烘焙点心'
				},{
					logo: 'https://qiniuimg.wurun.net/logo2.png',
					url: 'https://qiniuimg.wurun.net/%E6%96%B0%E7%89%88/brand3.png',
					tit: '厦门早餐工程',
					text: '时尚早餐+',
					text2:''
				}],
				box6: [{
					url: 'https://qiniuimg.wurun.net/pc/st10.jpg',
					tit: '叮~您的外卖已送达！请及时查收~',
					time: '2022-09-29',
					user:'WEROOM五润 2022-09-29 发表于福建',
					text: '五润外卖现已上线美团、饿了么平台及微信搜索五润Life小程序即刻下单。',
					cont:'<img src="https://qiniuimg.wurun.net/pc/st10.jpg" style="width:700px;margin:auto;"/><img src="https://qiniuimg.wurun.net/news/640-2.jpg"/><img src="https://qiniuimg.wurun.net/news/640.jpg"/>'
				},{
					url: 'https://qiniuimg.wurun.net/%E6%96%B0%E7%89%88/new2.jpg',
					tit: '厦门早餐工程又添两家新品牌！你尝鲜了吗？',
					time: '2022-04-21',
					user:'潇湘晨报官方百家号',
					text: '厦门早餐工程有新动作，每天清晨，在公交站、地铁口、写字楼下为市民提供早餐的餐车，是...',
					cont:'<img src="https://qiniuimg.wurun.net/news/640-3.jpg"/><text>图为新品牌九同味早餐经营点。（陈立新 摄）</text><img src="https://qiniuimg.wurun.net/news/640-4.jpg"/><text>九同味试水早餐工程进店经营。</text><text>厦门早餐工程有新动作。<br/>每天清晨，在公交站、地铁口、写字楼下为市民提供早餐的餐车，是一道暖心又熟悉的“风景线”，解决了行色匆匆的上班族吃早餐的实际需求。<br/>据了解，起步于上世纪90年代末的早餐工程，是厦门市委、市政府为民办实事的项目之一。记者随机采访发现，提起早餐工程，大众最熟知的是“早龙”“黄则和”两家企业。而近日，记者从市商务局获悉，五润（厦门）餐饮管理有限公司与厦门九同味生物科技有限公司也于近年申请下“厦门市早餐工程”商标的使用，正式成为我市早餐工程承办企业中的一员。新成员的加入会为市民早餐带来怎样的变化？已经承办早餐工程多年的企业又将有怎样的动作？记者进行深入采访。<br/>布局</text><text class="h4">两家新成员加入</text><br/><text class="h4">拟推出500个早餐工程点</text><br/><text class="h4">19日上午，记者在软件园二期的某栋办公楼内发现一家标有“九同味”“厦门市早餐工程”的经营点，排队购买早餐的上班族络绎不绝。随后，记者从其所属的厦门九同味生物科技有限公司了解到，该公司于去年正式成为厦门市早餐工程承办企业，目前除了软件园二期，还在观音山布局一处早餐工程经营点，并投入运营，并且根据该公司规划，预计今年将布局200个早餐工程经营点（含早餐车）。</text><br/><text>而同样是<em class="h4">厦门市早餐工程承办企业新成员的五润（厦门）餐饮管理有限公司也表示，今年计划布局300个早餐工程经营点（含早餐车）</em></text><br/><text>记者从市商务局获悉，截至2021年，我市共有2762个早餐工程经营点。考虑到丰富市民早餐菜单的需求，近年通过严格审核吸收新成员加入，进一步壮大服务民生的力量。新成员的加入不仅加速打造早餐消费新场景，织密便民早餐服务网，便捷市民购买，在丰富早餐菜单、筑牢食品安全等方面也将产生不小的影响。</text><br/><text>据介绍，厦门九同味生物科技有限公司从2012年开始致力于速冻米面制品的研发生产，其生产企业通过ISO22000食品安全管理体系认证，百余款早餐产品常年供应至五星级酒店、高校、便利店等多个机构，粗略统计，每年销售数千万个速冻米面制品。“依托已有的强大供应后盾，公司计划甄选销量大、比较受欢迎的传统大油条、煎饼及烤制产品等亮相早餐工程经营点，并将客单价控制在10元以内。”该公司负责人蔡荣泰介绍。</text><br/><text>五润方面则表示，公司目前在厦门有近40家连锁门店，2000多平方米的中央厨房主要生产面点，日常销售的早餐品种近30款，目前团队正在研究市民喜爱的早餐产品，丰富厦门市早餐工程市场。</text><br/><text>升级</text><br/><text class="h4">探索新能源加热方式 </text><br/><text class="h4">研发受欢迎的早餐新品</text><br/><text>采访中，不少业内人士提及，城市化的推进需要高颜值的早餐车，所以早餐车的升级改造也成为今年工作重点之一。<br/>记者走访发现，多家早餐工程承办企业的早餐车在实现即时加热功能上，使用的是小型煤气罐。一位不愿意透露姓名的业内人士确认了该情况，他介绍，业内也一直在探索新能源的使用，如果广大市民有更好的建议欢迎留言探讨。<br/>蔡荣泰在采访中透露，公司布局在写字楼的两处早餐工程经营点均使用电力实现即时加热，而即将面市的户外移动早餐车则受限于应用场景，不方便使用煤气、电，目前正在探索新能源的加热，以达到移动早餐车使用更安全、更环保美观的目的。<br/>新成员动作频频，作为承担了厦门市早餐工程二十余年的“元老级”成员——厦门早龙食品有限公司（以下简称“早龙”）又有何打算？据了解，<em class="h4">今年早龙计划斥资近200万元用于旗下移动早餐车形象配套的升级和改造</em>，包括餐车面板贴纸、太阳伞、工作服帽、保温箱贴纸等全面换新，进一步提升我市早餐工程的形象。<br/>早龙相关负责人介绍，公司从1998年就开始承办厦门市放心早餐工程，目前在全市6区共拥有1700多部早餐车，70余款早餐产品，为市民日供应近30万份早餐。“为满足市民日益多元化的消费需求，公司从未停止研发新品的脚步，比如去年上新的酸菜包、米汉堡等，米汉堡在受众群体中备受青睐，十分走俏。”该负责人表示，今年仍将继续新品开发，除了面点、糕点等主食，饮品的研发也是重心，力争为市民提供花式早餐、营养早餐。</text><br/><text>【市民寄语】</text><br/><text>【市民寄语】</text><br/><text class="h4">丰富早餐品类</text><br/><text class="h4">抓牢食品安全</text><br/><text>记者随机采访发现，面对早餐工程添新军，市民寄语要丰富早餐品类及抓牢食品安全。<br/>在软件园上班的95后张女士表示，虽然常见的主食无非是粥、馒头、包子等，但是如果能搭配些提前做好的小配菜就更完美了，并且希望可以增加些闽南风味的早餐。<br/>梁先生工作忙碌，是早餐车的铁杆消费者，他表示，增加新企业承办早餐工程很不错，能丰富早餐选择，但是希望抓牢食品安全管理。<br/>【相关新闻】</text><br/><text class="h4">早餐自律小组20多年来</text><br/><text class="h4">每天清晨抽查餐车产品</text><br/><text class="h4">记者从“厦门市早餐工程”商标拥有者——市商业联合会餐饮同业公会了解到，由厦门市商业联合会副秘书长暨早餐自律小组组长周敏带队的早餐自律小组，二十多年来，协同早餐工程承办企业成员，每天清晨随机抽查餐车产品，周敏也被亲切地称为“早餐打更人”。数据显示，2021年共组织常规检查300余次、早餐车2560部，协助处理多起市民投诉，认真落实疫情防控和食品卫生安全相关措施，定期组织开展从业人员燃气安全和食品卫生安全培训。</text><br/><text class="h4">鼓励早餐工程进店</text><br/><text class="h4">与餐车作相互补充</text><br/><text>近日，记者从厦门市商业联合会获悉，近年相关部门一直鼓励早餐工程进店经营，以现有的餐车占道经营和固定门店相结合，两者相互补充，而<em class="h4">厦门九同味生物科技有限公司在软件园二期写字楼内布局早餐工程经营点，便是早餐工程进店经营的缩影</em></text><br/><text>（厦门晚报记者 吴佳）</text><br/><text>【来源：厦门日报社】</text><br/><text>声明：转载此文是出于传递更多信息之目的。若有来源标注错误或侵犯了您的合法权益，请作者持权属证明与本网联系，我们将及时更正、删除，谢谢。 邮箱地址：newmedia@xxcb.cn</text>'
				},{
					url: 'https://qiniuimg.wurun.net/%E6%96%B0%E7%89%88/new3.jpg',
					tit: '厦门推出集体用餐配送，将为食堂...',
					time: '2020-02-02',
					user:'厦门网 2020-02-02 15:04 发表于福建',
					text: '为配合我市应对新型冠状病毒感染肺炎疫情工作，避免人员密集就餐，防止群体性聚餐可能...',
					cont:'<text style="text-align: center;display: block;font-weight:600;"> 明天起<br/>部分单位和企业就开始恢复上班了<br/>但是用餐问题怎么解决呢？<br/>注意啦！<text style="color:#00a367">厦门推出集体用餐配送！<br/>可为机关、团体、企业、事业单位食堂<br/>配送早、午、晚餐</text></text> <br/>为配合我市应对新型冠状病毒感染肺炎疫情工作，避免人员密集就餐，防止群体性聚餐可能引发的风险，根据《市应对新型冠状病毒感染肺炎疫情工作指挥部综合协调组转发〈福建省应对新型冠状病毒感染肺炎疫情工作领导小组综合协调组关于做好节后机关事业单位新型冠状病毒感染肺炎防控工作的通知〉的通知》，在市商务局指导下，市餐饮行业协会积极发动我市餐饮企业充分发挥行业优势，调整经营策略，履行社会责任，拟向我市机关、团体和企事业单位提供集体用餐供配送服务保障。<br/><text style="text-align: center;display: block;font-weight:600;color:#00a367">具体方案如下↓</text> <br/><text style="text-align: center;display: block;font-weight:600;">服务对象和范围</text><br/>我市范围内的机关、团体、企业、事业单位，包括早餐、午餐和晚餐。<br/><text style="text-align: center;display: block;font-weight:600;">订餐和配送方式</text><br/>实行单位团体订餐，由用餐需求单位统一与供餐企业提前以电话方式预订(早餐前一天12:00前预订，午餐和晚餐前一天16:00前预订)，供餐企业根据分餐制要求，按人头统一打包供应配餐，每人一份。<br/>供配送方式包括单位派人自取、餐企送餐上门(或到指定地点)和第三方提供配送服务(适用于通过第三方预订、线上预订)。<br/>家庭或个人订餐仍按现行办法，以市场化方式预订，不适用本方案。<br/><text style="text-align: center;display: block;font-weight:600;">价格和结算方式</text><br/>价格10元—40元/人·份，品种和结算方式由订餐单位选择，并与供餐企业协商确定。<br/><text style="text-align: center;display: block;font-weight:600;">供餐单位</text><br/>首批供餐企业包括美海乐、早龙、五润、夏商营养餐、家的味道、肯德基、利新源、美团外卖和饿了么9家<br/>在此基础上，将根据需求情况陆续征集新的供餐企业名单<br/><text style="text-align: center;display: block;font-weight:600;">食安保障</text><br/>各供餐企业承诺将严格按照《餐饮服务食品安全操作规范》、《关于餐饮企业做好疫情防控工作的通知》、《关于加强餐饮业新型冠状病毒感染肺炎疫情防控工作的紧急通知》、《关于餐饮服务单位学习防控新型冠状病毒相关知识的通知》和市市场监督管理局《致餐饮服务单位的一封信》，以及市、区政府的相关要求，认真落实各项防控措施，确保用餐食品的质量和安全。<br/>服务保障至疫情结束后自行解除。如有质量或安全问题，可向厦门市餐饮行业协会投诉。<br/><text style="text-align: center;display: block;font-weight:600;">转发扩散！<br/>有需要的企业和单位<br/>赶紧预定起来吧~</text>'
				}],
				box7: [{
					url: 'https://qiniuimg.wurun.net/php/new4.jpg',
					tit: '中华人民共和国食品安全法',
					time: '2021-12-10 ',
					user:'来源：厦门网',
					text: '为保证食品安全，保障公众身体健康和生命安全，制定本法',
					cont:'<text style="font-weight:600;">目　录</text><br/><text style="font-weight:500;">第一章　总　则<br/>第二章　食品安全风险监测和评估<br/>第三章　食品安全标准</text><br/><text style="font-weight:600;">第一章　总　则</text><br/>第一条　为保证食品安全，保障公众身体健康和生命安全，制定本法。<br/>第二条　在中华人民共和国境内从事下列活动，应当遵守本法：<br/>（一）食品生产和加工（以下称食品生产），食品流通和餐饮服务（以下称食品经营）；<br/>（二）食品添加剂的生产经营；<br/>（三）用于食品的包装材料、容器、洗涤剂、消毒剂和用于食品生产经营的工具、设备（以下称食品相关产品）的生产经营；<br/>（四）食品生产经营者使用食品添加剂、食品相关产品；<br/>（五）对食品、食品添加剂和食品相关产品的安全管理。<br/>供食用的源于农业的初级产品（以下称食用农产品）的质量安全管理，遵守《中华人民共和国农产品质量安全法》的规定。但是，制定有关食用农产品的质量安全标准、公布食用农产品安全,有关信息，应当遵守本法的有关规定。<br/>第三条　食品生产经营者应当依照法律、法规和食品安全标准从事生产经营活动，对社会和公众负责，保证食品安全，接受社会监督，承担社会责任。<br/>第四条　国务院设立食品安全委员会，其工作职责由国务院规定。<br/>国务院卫生行政部门承担食品安全综合协调职责，负责食品安全风险评估、食品安全标准制定、食品安全信息公布、食品检验机构的资质认定条件和检验规范的制定，组织查处食品安全重大事故。国务院质量监督、工商行政管理和国家食品药品监督管理部门依照本法和国务院规定的职责，分别对食品生产、食品流通、餐饮服务活动实施监督管理。<br/>第五条　县级以上地方人民政府统一负责、领导、组织、协调本行政区域的食品安全监督管理工作，建立健全食品安全全程监督管理的工作机制；统一领导、指挥食品安全突发事件应对工作；完善、落实食品安全监督管理责任制，对食品安全监督管理部门进行评议、考核。<br/>县级以上地方人民政府依照本法和国务院的规定确定本级卫生行政、农业行政、质量监督、工商行政管理、食品药品监督管理部门的食品安全监督管理职责。有关部门在各自职责范围内负责　本行政区域的食品安全监督管理工作。<br/>上级人民政府所属部门在下级行政区域设置的机构应当在所在地人民政府的统一组织、协调下，依法做好食品安全监督管理工作。<br/>第六条　县级以上卫生行政、农业行政、质量监督、工商行政管理、食品药品监督管理部门应当加强沟通、密切配合，按照各自职责分工，依法行使职权，承担责任。<br/>第七条　食品行业协会应当加强行业自律，引导食品生产经营者依法生产经营，推动行业诚信建设，宣传、普及食品安全知识。<br/>第八条　国家鼓励社会团体、基层群众性自治组织开展食品安全法律、法规以及食品安全标准和知识的普及工作，倡导健康的饮食方式，增强消费者食品安全意识和自我保护能力。<br/>新闻媒体应当开展食品安全法律、法规以及食品安全标准和知识的公益宣传，并对违反本法的行为进行舆论监督。<br/>第九条　国家鼓励和支持开展与食品安全有关的基础研究和应用研究，鼓励和支持食品生产经营者为提高食品安全水平采用先进技术和先进管理规范。<br/>第十条　任何组织或者个人有权举报食品生产经营中违反本法的行为，有权向有关部门了解食品安全信息，对食品安全监督管理工作提出意见和建议。<br/>第二章　食品安全风险监测和评估<br/>第十一条　国家建立食品安全风险监测制度，对食源性疾病、食品污染以及食品中的有害因素进行监测。<br/>国务院卫生行政部门会同国务院有关部门制定、实施国家食品安全风险监测计划。省、自治区、直辖市人民政府卫生行政部门根据国家食品安全风险监测计划，结合本行政区域的具体情况，组织制定、实施本行政区域的食品安全风险监测方案。<br/>第十二条　国务院农业行政、质量监督、工商行政管理和国家食品药品监督管理等有关部门获知有关食品安全风险信息后，应当立即向国务院卫生行政部门通报。国务院卫生行政部门会同有关部门对信息核实后，应当及时调整食品安全风险监测计划。<br/>第十三条　国家建立食品安全风险评估制度，对食品、食品添加剂中生物性、化学性和物理性危害进行风险评估。<br/>国务院卫生行政部门负责组织食品安全风险评估工作，成立由医学、农业、食品、营养等方面的专家组成的食品安全风险评估专家委员会进行食品安全风险评估。<br/>对农药、肥料、生长调节剂、兽药、饲料和饲料添加剂等的安全性评估，应当有食品安全风险评估专家委员会的专家参加。<br/>食品安全风险评估应当运用科学方法，根据食品安全风险监测信息、科学数据以及其他有关信息进行。<br/>第十四条　国务院卫生行政部门通过食品安全风险监测或者接到举报发现食品可能存在安全隐患的，应当立即组织进行检验和食品安全风险评估。<br/>第十五条　国务院农业行政、质量监督、工商行政管理和国家食品药品监督管理等有关部门应当向国务院卫生行政部门提出食品安全风险评估的建议，并提供有关信息和资料。<br/>国务院卫生行政部门应当及时向国务院有关部门通报食品安全风险评估的结果。<br/>第十六条　食品安全风险评估结果是制定、修订食品安全标准和对食品安全实施监督管理的科学依据。<br/>食品安全风险评估结果得出食品不安全结论的，国务院质量监督、工商行政管理和国家食品药品监督管理部门应当依据各自职责立即采取相应措施，确保该食品停止生产经营，并告知消费者　停止食用；需要制定、修订相关食品安全国家标准的，国务院卫生行政部门应当立即制定、修订。<br/>第十七条　国务院卫生行政部门应当会同国务院有关部门，根据食品安全风险评估结果、食品安全监督管理信息，对食品安全状况进行综合分析。对经综合分析表明可能具有较高程度安全风　险的食品，国务院卫生行政部门应当及时提出食品安全风险警示，并予以公布<br/>'
					}],
				newBtn:[{
					name:'五润动态'
				},{
					name:'行业动态'
				}],
				newBtnActive:0,
				height: 0, //窗口高度
				scrollTop: 0, //滚动高度
				osTop:0
			}
		},
		watch: {
			windowWidth: {
				handler(e) {
				},
				immediate: true,
				deep: true
			}
		},
		mounted() {
			this.$refs.student.$on('getStudent',this.getSwiper)
			setTimeout(() => {
				this.init = true
			}, 1000)
			this.height = document.documentElement.clientHeight;
			this.windowWidth = document.body.clientWidth
			this.myswiper()
			window.addEventListener("scroll", this.showbtn, true);
			window.addEventListener('resize', () => this.windowWidth = window.innerWidth, false)
			document.documentElement.scrollTop = document.body.scrollTop =0;
		},
		methods: {
			getSwiper(e){
				this.swiperIdx = e;
			},
			myswiper: function() {
				let that = this;
				var swiper = new Swiper('.swiper-container', {
					loop: false,
					pagination: {
						clickable:true,
						paginationType:"custom",
						pagination: '.swiper-pagination',
						paginationCustomRender:function(current, total){
							 var customPaginationHtml = "";
							 for (var i = 0; i < total; i++) {
              //判断哪个分页器此刻应该被激活
              if (i == current - 1) {
                customPaginationHtml +=
                  '<span class="swiper-pagination-customs swiper-pagination-customs-active"></span>';
              } else {
                customPaginationHtml +=
                  '<span class="swiper-pagination-customs"></span>';
              }
            }
            return '<span class="swiperPag">'+customPaginationHtml+'</span>';
						}
					}
				});
			},
			goToNewsList(){
				this.$bus.emit("tabIdx",4);
				this.$router.push({
					path: '/news',
					query: {
						tabIdx: 4
					}
				})
			},
			goToNewDetail(data){
				this.$bus.emit("tabIdx",4);
				sessionStorage.setItem('newsData', JSON.stringify(data))
				this.$router.push({
					path:'/newsDetail',
					query:{
						tabIdx:4,
						data
					}
				})
			},
			subNewBtn(i){
				this.newBtnActive = i
			},
			 debounce(func, wait) {
					let timeout;
					return function () {
							let context = this;
							let args = arguments;
							if (timeout) clearTimeout(timeout);
							timeout = setTimeout(() => {
									func.apply(context, args)
							}, wait);
					}
			},
			//判断滚动方向
			handleScroll(e){
					let direction = e.deltaY > 0 ? 'down' : 'up'
					let top = document.documentElement.scrollTop || document.body.scrollTop
					if(direction == 'down'){
						
					}
			},
			showbtn() {
				let that = this;
				that.scrollTop  = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
			},
			goToUrl(i) {
				this.$router.push({
					path: '/business',
					query: {
						i
					}
				})
			}
		}
	}
</script>

<style scoped>

</style>
